import { GraphQLClient } from "graphql-request";

const HASURA_URL =
  import.meta.env.VITE_HASURA_URL;
const HASURA_SECRET =
  import.meta.env.VITE_HASURA_ADMIN_SECRET;

export const gql = new GraphQLClient(HASURA_URL, {
  headers: {
    "x-hasura-admin-secret": HASURA_SECRET,
  },
});
